"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var GroupCard =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(GroupCard, _Card$makeDefaultCard);

  function GroupCard() {
    babelHelpers.classCallCheck(this, GroupCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(GroupCard).apply(this, arguments));
  }

  babelHelpers.createClass(GroupCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      return null;
    }
  }]);
  return GroupCard;
}(_base.default.makeDefaultCardType('group', 'Group'));

exports.default = GroupCard;